<template>
<modal-dialog :modal-visible="visible"
	:title="modalTitle"
	:confirm-button-text="clockIn ? 'Clock In' : 'Clock Out'"
	:working="working"
	v-on:closeModal="$emit('closeModal')"
	v-on:confirm="confirmGroupClock">

	<field :params="{type:'btn-group',buttons:[
			{text: 'Clock In',value: true},
			{text: 'Clock Out', value: false}
		]}"
		v-model="clockIn">
	</field>

	<template v-if="clockIn">
		<field label="Employees to Clock In"
			col-class='stacked'
			:params="{type:'select-multi',options:clockedOutUsersOptions}"
			v-model="selectedEmployees">
		</field>

		<field label="Time In Notes"
			col-class="stacked"
			:params="{type:'textarea'}"
			v-model="payload.time_in_notes">
		</field>

	</template>
	<p v-else-if="clockedInUsersOptions.length == 0" class="mt-4 text-center">
		There are no users currently clocked into this project
	</p>
	<template v-else>
		<field label="Employees to Clock Out"
			col-class='stacked'
			:params="{type:'checklist',options:clockedInUsersOptions}"
			v-model="selectedEmployees">
		</field>

		<form-group v-for="(payBoost,index) in $store.project.PayBoost" 
			:label="payBoost.description" 
			:key="'payboosts-'+payBoost.slug" 
			col-class="col-md-4 col-8 col-sm-4">

			<field :params="{type: 'boolean'}" 
				v-model="payload.payBoosts[payBoost.id]">
			</field>
			
		</form-group>

		<form-group label="Regular Hours" col-class="col-sm-4">

			<div class="d-flex flex-row align-items-center">
				<field v-model="payload.regular_hours"
					style="flex-grow: 1"
					:params="{'type': 'number',min:0,max:24,step:0.25,placeholder:'0.00'}">		
				</field>
				
				<div v-if="!overTimeHours">
					<button type="button" class="btn btn-light" v-on:click="overTimeHours = true" style="width: 100%;">
						<i class="fa fa-plus"></i>
						Overtime
					</button>
				</div>
			</div>

		</form-group>

		<div v-if="overTimeHours">

			<h4>Overtime Hours</h4>

			<field v-if="$store.timeLogSettings.uses_overtime_15x == 1" 
				label="Overtime x1.5" 
				col-class="col-6 col-sm-4" 
				v-model="payload.overtime_hours_15x" 
				:params="{'type': 'number',min:0,max:24,step:0.25,placeholder:'0.00'}">	
			</field>

			<field v-if="$store.timeLogSettings.uses_overtime_2x == 1" 
				label="Overtime x2.0" 
				col-class="col-6 col-sm-4" 
				v-model="payload.overtime_hours_2x" 
				:params="{'type': 'number',min:0,max:24,step:0.25,placeholder:'0.00'}">
			</field>

			<field v-if="$store.timeLogSettings.uses_overtime_25x == 1" 
				label="Overtime x2.5" 
				col-class="col-6 col-sm-4" 
				v-model="payload.overtime_hours_25x" 
				:params="{'type': 'number',min:0,max:24,step:0.25,placeholder:'0.00'}">	
			</field>

		</div>

		<field label="Clock Out Remarks" 
			col-class="col-md-4" 
			v-model="payload.time_out_notes" 
			:params="{type:'textarea',size:'xsm'}">
		</field>

	</template>

</modal-dialog>
</template>
<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"

export default {

	name: 'GroupClockModal',
	components: {
		ModalDialog,
		Field,
		FormGroup
	},
	props: [
		"visible",
		"serviceId",
		"projectId"
	],
	data() {
		return {
			openTimeLogs: [],
			clockedOutUsers: [],
			clockIn: true,
			overTimeHours: false,
			selectedEmployees: [],
			working: false,
			payload: {
				payBoosts: {}
			}
		}
	},
	watch: {
		visible() {
			if (this.visible)
				this.init()
		}
	},
	computed: {
		/*openTimeLogs() {
			let openTimeLogs = []
			if (this.projectId > 0)
				openTimeLogs = this.$store.jobOpenTimelogs
			else
				openTimeLogs = this.$store.service.TimeLog.filter(log => !log.time_out || log.time_out == '0000-00-00 00:00:00')

			return openTimeLogs
		},*/
		modalTitle() {
			if (this.projectId > 0)
				return 'Group Clock In/Out: Project #'+this.$store.project.job_num
			else if (this.serviceId > 0)
				return "Group Clock In/Out: Service #"+this.$store.service.job_num
			else
				return "Group Click In/Out"
		},
		clockedInUsersOptions() {

			return this.optionify(this.openTimeLogs.map(log => {
				return {
					fullName: log.User.first_name + " " + log.User.last_name,
					id: log.User.id
				}
			}),'fullName')
		},
		clockedOutUsersOptions() {
			return this.optionify(this.clockedOutUsers.map(user => {
				user.fullName = user.first_name+" "+user.last_name
				return user
			}),"fullName")
		},
	},
	methods: {
		init() {
			let vm = this
			if (this.$store.jobOpenTimelogs.length == 0)
				this.clockIn = true
			else
				this.clockIn = false

			this.getLocation().then(location => {
				vm.payload.currentLat = location.lat
				vm.payload.currentLong = location.lng
				vm.payload.position_accuracy = location.accuracy
			})

			let timeLogParams = {
				include: [{
					model: "User",
					include: ["EmployeeClassification"],
					fields: ["id","slug","first_name","last_name"]
				}],
				fields: [
					"id",
					"slug",
					"regular_hours",
					"overtime_hours_15x",
					"overtime_hours_2x",
					"overtime_hours_25x",
					"user_id",
					"service_id",
					"job_id",
					"collective_agreement_json",
					"time_in",
					"time_out",
					"time_on_site"
				]
			}

			if (this.serviceId)
				timeLogParams.filters = [["service_id",this.serviceId]]
			else if (this.projectId)
				timeLogParams.filters = [["job_id",this.projectId]]

			this.getJSON("OpenTimeLog/get",timeLogParams).then(response => {
				if (response.success) 
					vm.openTimeLogs = response.data
			})

			this.fetchUsers([["clocked_in",0]],"clockedOutUsers",["id","slug","first_name","last_name","clocked_in"])
		},
		confirmGroupClock() {
			let vm = this

			let promises = []

			let payload = this.cloneObj(vm.payload)

			this.working = true

			this.selectedEmployees.forEach(empId => {
				if (empId > 0) {
					if (vm.clockIn) {
						//clock in
						payload.user_id = empId,
						payload.job_id = vm.projectId
						payload.service_id = vm.serviceId
						payload.time_in_notes = vm.payload.time_in_notes
					}
					else {
						//clock out
						//find log id
						let openLog = vm.openTimeLogs.find(log => log.user_id == empId)

						if (openLog) {
							payload.user_id = empId
							payload.id = openLog.id
						}

						payload.request = "clockOut"
					}

					promises.push(vm.postData("TimeLog/punch-clock",payload))
				}
			})

			Promise.all(promises).then(responses => {
				let errorMessages= []

				vm.usersClockedInFetchTrigger++

				vm.working = false

				let clockInCnt = 0
				responses.forEach(response => {
					if (!response.success && "errors" in response)
						errorMessages = errorMessages.concat(response.errors)
					else
						clockInCnt++
				})

				if (vm.clockIn && clockInCnt > 0) {
					vm.alertSuccess(clockInCnt+" users have been clocked in")
					vm.$emit('usersClockedIn')
				}
				else if (!vm.clockIn && clockInCnt > 0) {
					vm.alertSuccess(clockInCnt+" users have been clocked out")
					vm.$emit('usersClockedOut')
				}

				if (errorMessages.length > 0)
					vm.alertErrors(errorMessages)
				else
					vm.$emit('closeModal')
			})
		}
	},
	created() {
		if (this.visible)
			this.init()
	}
}

</script>